import {
  createAsyncThunk,
  createSlice,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import { client } from "../../api/client";
import { globalConstants } from "../../constants/global.constants";

const categoryAdapter = createEntityAdapter();

const initialState = categoryAdapter.getInitialState({
  status: globalConstants.IDLE,
});

export const handleCategory = createAsyncThunk(
  "category/handleCategory",
  async (categoryData, thunkAPI) => {
    try {
      const response = await client.post("handle_category", categoryData);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {},
  extraReducers: {
    [handleCategory.pending]: (state, action) => {
      state.status = globalConstants.LOADING;
    },
    [handleCategory.fulfilled]: (state, action) => {
      state.status = globalConstants.SUCCEEDED;
    },
    [handleCategory.rejected]: (state, action) => {
      state.status = globalConstants.ERROR;
    },
  },
});

export default categorySlice.reducer; 